export default {
    title: '헤더',
    classInfo: {
        school: '학교',
        studentsCount: '학생 수',
        classroomCode: '학급 코드',
        qrCode: {
            title: 'QR 코드',
            view: 'QR 코드 보기',
            description: '학생들이 이 QR 코드를 스캔하면 바로 학급에 입장할 수 있어요.',
        },
    },
    qrCodeModal: {
        description: '학생이 QR 코드를 스캔하면 출석번호와 이름을\n입력하는 화면으로 바로 이동합니다.',
        qrCodeRendered: 'QR 코드가 여기에 표시됩니다',
        fullscreen: '전체 화면으로 보기',
        qrCodeAlt: '학급코드 QR',
        error: 'QR 코드 생성 오류:',
        success: 'URL이 복사되었습니다.',
        failed: 'URL 복사에 실패했습니다.',
    },
};
